(() => {
  const initHeader = (header) => {
    if (!header || header.dataset.gmInitialized === 'true') return;
    header.dataset.gmInitialized = 'true';

    const button = header.querySelector('[data-gm-menu-button]');
    const menu = header.querySelector('[data-gm-menu]');
    const backdrop = header.querySelector('[data-gm-backdrop]');
    const label = header.querySelector('[data-gm-menu-label]');

    if (!button || !menu) return;

    const setOpen = (open) => {
      header.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
      if (label) label.textContent = open ? 'Close' : 'Menu';
    };

    button.addEventListener('click', () => {
      setOpen(!header.classList.contains('is-open'));
    });

    backdrop?.addEventListener('click', () => setOpen(false));

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && header.classList.contains('is-open')) {
        setOpen(false);
        button.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!header.classList.contains('is-open')) return;
      if (header.contains(event.target)) return;
      setOpen(false);
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-gm-header]').forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();